export const selectOptions = [
    { value: "inform_bse_team", label: "Inform BSE team about resource release" },
    { value: "revoke_access_wm_bays", label: "Send out a note to the WM team to revoke access to the Walmart Bays and/or Lab" },
    { value: "revoke_walmart_ids", label: "Raise a request to revoke the Walmart IDs" },
    { value: "remove_from_vlan", label: "Raise a iSolve request to take off associate from Walmart VLAN" },
    { value: "remove_from_dls", label: "Ensure that the associate is taken off from every Walmart DLs" },
    { value: "remove_from_kubera", label: "Removing access to Kubera Project Site" },
    { value: "return_items", label: "Ensure that laptops / mobile phones / SIM card are returned" },
    { value: "update_reporting_manager", label: "Ensure that Reporting Manager change is initiated in Orion" }
  ];